import(/* webpackMode: "eager" */ "/home/jenkins/workspace/prod/rollback-frontend/src/app/global-error.tsx");
